// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Theme tokens — the six colors this stylesheet (and colors.premium.js /
   colors.standard.js on the MUI side) actually vary between the default
   premium theme and the standard (embedded, close-to-original) theme.
   index.js toggles the psb-theme-standard class on <html> at boot based on
   the PSB_THEME embed marker; keep these values in sync with their MUI
   palette counterparts if either changes. */
:root {
  --psb-bg: #FBF7EE;
  --psb-dark: #1D1C2A;
  --psb-accent: #B9860F;
  --psb-accent-rgb: 185, 134, 15;
  --psb-border-light: #E1DEEA;
  --psb-border-dark: #C7C3D6;
  --psb-text-muted: #423F58;
}

html.psb-theme-standard {
  --psb-bg: #ffffff;
  --psb-dark: #344767;
  --psb-accent: #5b96a9;
  --psb-accent-rgb: 91, 150, 169;
  --psb-border-light: #dee2e6;
  --psb-border-dark: #ced4da;
  --psb-text-muted: #7b809a;
}

/* Cafe page — category jump-links, previously plain grey (#ddd/#666)
   outlined buttons with manual margins. Now rounded pills on a flex/gap
   list with a gold hover/active state matching the rest of the theme. */
.psb-category-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.psb-category-chip-list .nav-item {
  margin: 0;
}

.psb-category-chip.MuiButton-root {
  border-radius: 999px !important;
  border: 1px solid var(--psb-border-dark) !important;
  color: var(--psb-text-muted) !important;
  background-color: #ffffff !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 6px 16px !important;
  transition: border-color 150ms ease, color 150ms ease, background-color 150ms ease;
}

.psb-category-chip.MuiButton-root:hover {
  border-color: var(--psb-accent) !important;
  color: var(--psb-accent) !important;
  background-color: rgba(var(--psb-accent-rgb), 0.08) !important;
}

/* Login / create-account modal — full-screen page-overlay treatment
   instead of a small centered dialog box. */
.psb-page-overlay .modal-content {
  background-color: var(--psb-bg);
  border-radius: 0;
  border: none;
}

.psb-page-overlay .modal-header {
  background-color: #ffffff;
  border-bottom: 1px solid var(--psb-border-light);
  padding: 20px 32px;
}

.psb-page-overlay .modal-title {
  font-family: "Fraunces", "Georgia", serif;
  font-weight: 600;
  color: var(--psb-dark);
  font-size: 36px;
  line-height: 1.25;
}

.psb-page-overlay .modal-body {
  padding: 40px 24px 24px;
  max-height: none;
  overflow-y: auto;
  /* Required alongside .modal-content > * below: a flex item's default
     min-height is auto (its content size), not 0, so without this it grows
     to fit all content instead of shrinking to the space the flex column
     actually gives it -- which defeats the internal-scroll behavior that
     rule is meant to enable. */
  min-height: 0;
}

.psb-page-overlay.psb-overlay-narrow .modal-body {
  max-width: 560px;
  margin: 0 auto;
  width: 100%;
}

.psb-page-overlay.psb-overlay-medium .modal-body {
  max-width: 760px;
  margin: 0 auto;
  width: 100%;
}

.psb-page-overlay.psb-overlay-wide .modal-body {
  max-width: 1100px;
  margin: 0 auto;
  width: 100%;
}

/* Modals with no width tier (e.g. product view) fill the full page width;
   react-bootstrap's own <Container> would otherwise re-impose its default
   responsive max-width and leave the content and scrollbar inset from the
   page edge, so it is neutralized here. */
.psb-page-overlay:not(.psb-overlay-narrow):not(.psb-overlay-medium):not(.psb-overlay-wide) .modal-body .container {
  max-width: 100%;
}

.psb-page-overlay .modal-footer {
  background-color: #ffffff;
  border-top: 1px solid var(--psb-border-light);
}

/* Several modals (registration, family member, cancel account, memberships)
   wrap Header/Body/Footer in a <form> for submission; others render them
   under a plain wrapper <div> instead. Either way, that wrapper becomes the
   sole child of the fullscreen .modal-content flex column, but a plain
   <form>/<div> has no flex sizing of its own, so it shrinks to its content
   height instead of filling the viewport. Concretely, this is what caused
   the "backdrop visible under the modal while scrolling" bug: .modal-body's
   flex:1 1 auto (from Bootstrap) only takes effect if ITS immediate parent
   is the flex column -- when that parent is instead this unconstrained
   wrapper, modal-body just grows to its full content height and overflows
   past modal-content's own (correctly viewport-height-capped, colored)
   box, rendering on bare transparent space with only the dimmed page
   backdrop behind it. Making the wrapper itself a flex column (mirroring
   .modal-content) lets the existing .modal-body { flex: 1 1 auto } inside
   it work as intended, so modal-body properly clips to the remaining space
   and scrolls its own overflow internally instead.

   IMPORTANT: some other modals (e.g. the cart) render .modal-header and
   .modal-body as DIRECT children of .modal-content, with no wrapper at all
   -- Bootstrap's own base rules already size those correctly on their own
   (.modal-header has flex-shrink:0 so it stays content-sized; .modal-body
   already has flex:1 1 auto). Targeting a bare "> *" hit those too and gave
   .modal-header flex:1 1 auto it was never meant to have, so it grew to
   share the available space with .modal-body 50/50 -- a way-too-tall empty
   header above the content. Excluding .modal-header/.modal-body/.modal-footer
   keeps this rule scoped to only the actual wrapper element. */
.psb-page-overlay .modal-content > :not(.modal-header):not(.modal-body):not(.modal-footer) {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.psb-page-overlay .btn-close {
  opacity: 0.55;
  transition: opacity 150ms ease;
}

.psb-page-overlay .btn-close:hover {
  opacity: 1;
}

/* Nav bar polish — background/text color intentionally left as-is (tenant-
   configurable via SITE_OPTIONS.menu.fontColor); this only adds spacing,
   a hairline separator, hover affordance, and a gold active-item indicator. */
#psb-header {
  border-bottom: 1px solid var(--psb-border-light);
}

.tab-navigation {
  gap: 8px;
  align-items: center;
}

.tab-navigation .tab-item > a,
.tab-navigation .tab-item > button {
  border-radius: 10px;
  transition: background-color 150ms ease;
}

.tab-navigation .tab-item > a:hover,
.tab-navigation .tab-item > button:hover {
  background-color: rgba(var(--psb-accent-rgb), 0.1);
}

.tab-navigation .underline {
  text-decoration: none !important;
  position: relative;
  display: inline-block;
  font-weight: 700;
}

.tab-navigation .underline::after {
  content: "";
  position: absolute;
  left: 2px;
  right: 2px;
  bottom: -8px;
  height: 2px;
  border-radius: 2px;
  background: var(--psb-accent);
}

/* Play Space Brain theme — global type, applied at the raw-tag level since
   this app mixes plain HTML headings with MUI Typography components. */
body, html {
  font-family: "Manrope", "Helvetica", "Arial", sans-serif;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: "Fraunces", "Georgia", serif;
  font-weight: 600;
  color: var(--psb-dark);
}

html body {
  max-width: 100%;
  max-height: 100vh;
  font-size: 0.9rem;
}

.event-disabled {
  opacity: 0.6;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow: hidden;
  overflow-y: auto;
}

.modal-overflow-100 {
  max-height: 95vh;
}

#psb-header {
  text-align: center;
  display: block;
  border: 1px solid var(--psb-border-light);
  background: var(--psb-bg);
  padding-bottom: 4px;
}
#psb-header.customer-header {
  background: #fff;
  border-bottom: solid 1px var(--psb-border-light);
  padding-top: 25px;
  top: 0;
  z-index: 2;
}

.MuiPaper-root {
  border: none;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(29, 28, 42, 0.06), 0 12px 28px -14px rgba(29, 28, 42, 0.28);
}

.MuiPaper-root:hover {
  box-shadow: 0 2px 4px rgba(29, 28, 42, 0.08), 0 20px 40px -16px rgba(29, 28, 42, 0.35);
}

#psb-header {
  text-align: center;
  display: block;
  border: 1px solid var(--psb-border-light);
  background: var(--psb-bg);
  padding-bottom: 4px;
}

.rounded-item {
  border: solid 1px red;
  border-radius: 200px;
  padding: 20px 10px;
  margin: -20px 0 -20px 0 !important;
}

.ck-editor__editable {
  min-height: 400px;
}

.ck.ck-balloon-panel.ck-balloon-panel_position_border-side_right.ck-powered-by-balloon {
  display: none;
  position: absolute;
  left: -99999em;
}

.modal {
  z-index: 1250;
}

.modal-backdrop {
  z-index: 1210;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  width: auto !important;
  height: auto !important;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-default {
  cursor: default;
}

.text-right {
  text-align: right;
}

.react-datepicker-wrapper {
  width: 100%;
}
.react-datepicker-wrapper .form-control {
  font-size: 0.9rem;
  font-weight: 100;
  height: 2.6rem;
}

.modal-picker {
  z-index: 999;
  position: relative;
}

a.fc-col-header-cell-cushion, a.fc-daygrid-day-number {
  text-decoration: none;
  color: var(--bs-secondary);
}

a.fc-event {
  cursor: pointer;
}

.fc {
  --fc-button-bg-color: var(--psb-accent);
  --fc-button-border-color: var(--psb-accent);
  --fc-button-hover-bg-color: var(--psb-accent);
  --fc-button-hover-border-color: var(--psb-accent);
  --fc-button-active-bg-color: var(--psb-accent);
  --fc-button-active-border-color: var(--psb-accent);
  --fc-button-text-color: #fff;
}

.fc .fc-button:active, .fc .fc-button:not(:disabled).fc-button-active {
  opacity: 0.85;
}

.bg-invalid-event {
  cursor: auto;
  background: #ccc !important;
}

.modal-card {
  box-shadow: 0 12px 28px -14px rgba(29, 28, 42, 0.35);
  border-radius: 14px;
}

.bg-primary {
  background: #a1c2e6 !important;
}

.bg-info {
  background: rgba(161, 194, 230, 0.7607843137) !important;
}

.underline {
  text-decoration: underline;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.spin {
  animation: spin 1000ms linear infinite;
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}

.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}

.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}

.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

.toggle-wrapper {
  overflow: hidden;
  transition: height 0.3s ease;
  position: relative;
  padding-bottom: 20px;
}

.toggle-content {
  transition: opacity 0.2s ease;
  opacity: 1;
  padding-right: 60px;
}

.m-chip {
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.fc-daygrid-event.fc-daygrid-block-event {
  background-color: transparent !important;
  border: none !important;
}

.fc-daygrid-event.fc-daygrid-block-event .fc-event-title {
  color: #000 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/psb-helpers.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;4CAAA;AAMA;EACE,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;AAEF;;AAAA;EACE,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;AAGF;;AACA;;wEAAA;AAGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAEF;;AAAA;EACE,SAAA;AAGF;;AADA;EACE,+BAAA;EACA,mDAAA;EACA,uCAAA;EACA,oCAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EACA,kFAAA;AAIF;;AAFA;EACE,0CAAA;EACA,mCAAA;EACA,8DAAA;AAKF;;AAFA;4CAAA;AAEA;EACE,+BAAA;EACA,gBAAA;EACA,YAAA;AAKF;;AAHA;EACE,yBAAA;EACA,gDAAA;EACA,kBAAA;AAMF;;AAJA;EACE,yCAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AAOF;;AALA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA;;;;+BAAA;EAKA,aAAA;AAQF;;AANA;EACE,gBAAA;EACA,cAAA;EACA,WAAA;AASF;;AAPA;EACE,gBAAA;EACA,cAAA;EACA,WAAA;AAUF;;AARA;EACE,iBAAA;EACA,cAAA;EACA,WAAA;AAWF;;AATA;;;0CAAA;AAIA;EACE,eAAA;AAYF;;AAVA;EACE,yBAAA;EACA,6CAAA;AAaF;;AAXA;;;;;;;;;;;;;;;;;;;;;;;;;+DAAA;AA0BA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;AAcF;;AAZA;EACE,aAAA;EACA,8BAAA;AAeF;;AAbA;EACE,UAAA;AAgBF;;AAbA;;8EAAA;AAGA;EACE,gDAAA;AAgBF;;AAdA;EACE,QAAA;EACA,mBAAA;AAiBF;;AAfA;;EAEE,mBAAA;EACA,uCAAA;AAkBF;;AAhBA;;EAEE,kDAAA;AAmBF;;AAjBA;EACE,gCAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AAoBF;;AAlBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;AAqBF;;AAlBA;uEAAA;AAEA;EACE,wDAAA;AAqBF;;AAlBA;;EAEE,yCAAA;EACA,gBAAA;EACA,sBAAA;AAqBF;;AAnBA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;AAsBF;;AAnBA;EACE,YAAA;AAsBF;;AApBA;EACE,+BAAA;EACA,gBAAA;EACA,gBAAA;AAuBF;;AApBA;EACE,gBAAA;AAuBF;;AApBA;EACE,kBAAA;EACA,cAAA;EACA,yCAAA;EACA,yBAAA;EACA,mBAAA;AAuBF;AAtBE;EACE,gBAAA;EACA,gDAAA;EACA,iBAAA;EACA,MAAA;EACA,UAAA;AAwBJ;;AApBA;EACE,YAAA;EACA,mBAAA;EACA,sFAAA;AAuBF;;AApBA;EACE,sFAAA;AAuBF;;AApBA;EACE,kBAAA;EACA,cAAA;EACA,yCAAA;EACA,yBAAA;EACA,mBAAA;AAuBF;;AApBA;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kCAAA;AAuBF;;AApBA;EACE,iBAAA;AAuBF;;AApBA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AAuBF;;AAnBA;EACE,aAAA;AAsBF;;AAnBA;EACE,aAAA;EAUA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AAaF;;AAVA;EACE,eAAA;AAaF;;AAVA;EACE,eAAA;AAaF;;AAVA;EACE,iBAAA;AAaF;;AAVA;EAOE,WAAA;AAOF;AAbE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAeJ;;AATA;EACE,YAAA;EACA,kBAAA;AAYF;;AATA;EACE,qBAAA;EACA,0BAAA;AAYF;;AATA;EACE,eAAA;AAYF;;AATA;EACE,uCAAA;EACA,2CAAA;EACA,6CAAA;EACA,iDAAA;EACA,8CAAA;EACA,kDAAA;EACA,4BAAA;AAYF;;AATA;EACE,aAAA;AAYF;;AATA;EACE,YAAA;EACA,2BAAA;AAYF;;AATA;EACE,oDAAA;EACA,mBAAA;AAYF;;AATA;EACE,8BAAA;AAYF;;AATA;EACE,wDAAA;AAYF;;AATA;EACE,0BAAA;AAYF;AASA;EACE;IACE,uBAAA;EAUF;EARA;IACE,yBAAA;EAUF;AACF;AAPA;EACE,sCAAA;AASF;;AALA;EACE,0BAAA;EACA,0DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;EACA,uBAAA;EACA,oCAAA;AAQF;;AALA;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AAQF;;AALA;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AAQF;;AALA;EACE,oBAAA;EACA,yBAAA;EAEA,iBAAA;EACA,6CAAA;AAQF;;AALA;EACE,wCAAA;AAQF;;AALA;EACE,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,oBAAA;AAQF;;AALA;EACE,6BAAA;EACA,UAAA;EACA,mBAAA;AAQF;;AALA;EACE,qBAAA;EACA,sBAAA;AAQF;;AALA;EACE,gCAAA;AAQF;;AANA;EACE;IACE,gBAAA;EASF;AACF;AAPA;EACE,UAAA;AASF;;AANA;EAA2C,wCAAA;EAA0C,uBAAA;AAWrF;;AAX+G;EAA2D,sBAAA;AAe1K","sourcesContent":["/* Theme tokens — the six colors this stylesheet (and colors.premium.js /\n   colors.standard.js on the MUI side) actually vary between the default\n   premium theme and the standard (embedded, close-to-original) theme.\n   index.js toggles the psb-theme-standard class on <html> at boot based on\n   the PSB_THEME embed marker; keep these values in sync with their MUI\n   palette counterparts if either changes. */\n:root {\n  --psb-bg: #FBF7EE;\n  --psb-dark: #1D1C2A;\n  --psb-accent: #B9860F;\n  --psb-accent-rgb: 185, 134, 15;\n  --psb-border-light: #E1DEEA;\n  --psb-border-dark: #C7C3D6;\n  --psb-text-muted: #423F58;\n}\nhtml.psb-theme-standard {\n  --psb-bg: #ffffff;\n  --psb-dark: #344767;\n  --psb-accent: #5b96a9;\n  --psb-accent-rgb: 91, 150, 169;\n  --psb-border-light: #dee2e6;\n  --psb-border-dark: #ced4da;\n  --psb-text-muted: #7b809a;\n}\n\n\n/* Cafe page — category jump-links, previously plain grey (#ddd/#666)\n   outlined buttons with manual margins. Now rounded pills on a flex/gap\n   list with a gold hover/active state matching the rest of the theme. */\n.psb-category-chip-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.psb-category-chip-list .nav-item {\n  margin: 0;\n}\n.psb-category-chip.MuiButton-root {\n  border-radius: 999px !important;\n  border: 1px solid var(--psb-border-dark) !important;\n  color: var(--psb-text-muted) !important;\n  background-color: #ffffff !important;\n  font-weight: 600 !important;\n  text-transform: none !important;\n  padding: 6px 16px !important;\n  transition: border-color 150ms ease, color 150ms ease, background-color 150ms ease;\n}\n.psb-category-chip.MuiButton-root:hover {\n  border-color: var(--psb-accent) !important;\n  color: var(--psb-accent) !important;\n  background-color: rgba(var(--psb-accent-rgb), 0.08) !important;\n}\n\n/* Login / create-account modal — full-screen page-overlay treatment\n   instead of a small centered dialog box. */\n.psb-page-overlay .modal-content {\n  background-color: var(--psb-bg);\n  border-radius: 0;\n  border: none;\n}\n.psb-page-overlay .modal-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid var(--psb-border-light);\n  padding: 20px 32px;\n}\n.psb-page-overlay .modal-title {\n  font-family: \"Fraunces\", \"Georgia\", serif;\n  font-weight: 600;\n  color: var(--psb-dark);\n  font-size: 36px;\n  line-height: 1.25;\n}\n.psb-page-overlay .modal-body {\n  padding: 40px 24px 24px;\n  max-height: none;\n  overflow-y: auto;\n  /* Required alongside .modal-content > * below: a flex item's default\n     min-height is auto (its content size), not 0, so without this it grows\n     to fit all content instead of shrinking to the space the flex column\n     actually gives it -- which defeats the internal-scroll behavior that\n     rule is meant to enable. */\n  min-height: 0;\n}\n.psb-page-overlay.psb-overlay-narrow .modal-body {\n  max-width: 560px;\n  margin: 0 auto;\n  width: 100%;\n}\n.psb-page-overlay.psb-overlay-medium .modal-body {\n  max-width: 760px;\n  margin: 0 auto;\n  width: 100%;\n}\n.psb-page-overlay.psb-overlay-wide .modal-body {\n  max-width: 1100px;\n  margin: 0 auto;\n  width: 100%;\n}\n/* Modals with no width tier (e.g. product view) fill the full page width;\n   react-bootstrap's own <Container> would otherwise re-impose its default\n   responsive max-width and leave the content and scrollbar inset from the\n   page edge, so it is neutralized here. */\n.psb-page-overlay:not(.psb-overlay-narrow):not(.psb-overlay-medium):not(.psb-overlay-wide) .modal-body .container {\n  max-width: 100%;\n}\n.psb-page-overlay .modal-footer {\n  background-color: #ffffff;\n  border-top: 1px solid var(--psb-border-light);\n}\n/* Several modals (registration, family member, cancel account, memberships)\n   wrap Header/Body/Footer in a <form> for submission; others render them\n   under a plain wrapper <div> instead. Either way, that wrapper becomes the\n   sole child of the fullscreen .modal-content flex column, but a plain\n   <form>/<div> has no flex sizing of its own, so it shrinks to its content\n   height instead of filling the viewport. Concretely, this is what caused\n   the \"backdrop visible under the modal while scrolling\" bug: .modal-body's\n   flex:1 1 auto (from Bootstrap) only takes effect if ITS immediate parent\n   is the flex column -- when that parent is instead this unconstrained\n   wrapper, modal-body just grows to its full content height and overflows\n   past modal-content's own (correctly viewport-height-capped, colored)\n   box, rendering on bare transparent space with only the dimmed page\n   backdrop behind it. Making the wrapper itself a flex column (mirroring\n   .modal-content) lets the existing .modal-body { flex: 1 1 auto } inside\n   it work as intended, so modal-body properly clips to the remaining space\n   and scrolls its own overflow internally instead.\n\n   IMPORTANT: some other modals (e.g. the cart) render .modal-header and\n   .modal-body as DIRECT children of .modal-content, with no wrapper at all\n   -- Bootstrap's own base rules already size those correctly on their own\n   (.modal-header has flex-shrink:0 so it stays content-sized; .modal-body\n   already has flex:1 1 auto). Targeting a bare \"> *\" hit those too and gave\n   .modal-header flex:1 1 auto it was never meant to have, so it grew to\n   share the available space with .modal-body 50/50 -- a way-too-tall empty\n   header above the content. Excluding .modal-header/.modal-body/.modal-footer\n   keeps this rule scoped to only the actual wrapper element. */\n.psb-page-overlay .modal-content > :not(.modal-header):not(.modal-body):not(.modal-footer) {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n.psb-page-overlay .btn-close {\n  opacity: 0.55;\n  transition: opacity 150ms ease;\n}\n.psb-page-overlay .btn-close:hover {\n  opacity: 1;\n}\n\n/* Nav bar polish — background/text color intentionally left as-is (tenant-\n   configurable via SITE_OPTIONS.menu.fontColor); this only adds spacing,\n   a hairline separator, hover affordance, and a gold active-item indicator. */\n#psb-header {\n  border-bottom: 1px solid var(--psb-border-light);\n}\n.tab-navigation {\n  gap: 8px;\n  align-items: center;\n}\n.tab-navigation .tab-item > a,\n.tab-navigation .tab-item > button {\n  border-radius: 10px;\n  transition: background-color 150ms ease;\n}\n.tab-navigation .tab-item > a:hover,\n.tab-navigation .tab-item > button:hover {\n  background-color: rgba(var(--psb-accent-rgb), 0.1);\n}\n.tab-navigation .underline {\n  text-decoration: none !important;\n  position: relative;\n  display: inline-block;\n  font-weight: 700;\n}\n.tab-navigation .underline::after {\n  content: \"\";\n  position: absolute;\n  left: 2px;\n  right: 2px;\n  bottom: -8px;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--psb-accent);\n}\n\n/* Play Space Brain theme — global type, applied at the raw-tag level since\n   this app mixes plain HTML headings with MUI Typography components. */\nbody, html {\n  font-family: \"Manrope\", \"Helvetica\", \"Arial\", sans-serif;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: \"Fraunces\", \"Georgia\", serif;\n  font-weight: 600;\n  color: var(--psb-dark);\n}\nhtml body {\n  max-width: 100%;\n  max-height: 100vh;\n  font-size: 0.9rem;\n}\n\n.event-disabled {\n  opacity: 0.6;\n}\n.modal-body {\n  max-height: calc(100vh - 200px);\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.modal-overflow-100 {\n  max-height: 95vh;\n}\n\n#psb-header {\n  text-align: center;\n  display: block;\n  border: 1px solid var(--psb-border-light);\n  background: var(--psb-bg);\n  padding-bottom: 4px;\n  &.customer-header {\n    background: #fff;\n    border-bottom: solid 1px var(--psb-border-light);\n    padding-top: 25px;\n    top: 0;\n    z-index: 2;\n  }\n}\n\n.MuiPaper-root {\n  border: none;\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(29,28,42,0.06), 0 12px 28px -14px rgba(29,28,42,0.28);\n}\n\n.MuiPaper-root:hover {\n  box-shadow: 0 2px 4px rgba(29,28,42,0.08), 0 20px 40px -16px rgba(29,28,42,0.35);\n}\n\n#psb-header {\n  text-align: center;\n  display: block;\n  border: 1px solid var(--psb-border-light);\n  background: var(--psb-bg);\n  padding-bottom: 4px;\n}\n\n.rounded-item {\n  border: solid 1px red;\n  border-radius: 200px;\n  padding: 20px 10px;\n  margin: -20px 0 -20px 0 !important;\n}\n\n.ck-editor__editable {\n  min-height: 400px;\n}\n\n.ck.ck-balloon-panel.ck-balloon-panel_position_border-side_right.ck-powered-by-balloon {\n  display: none;\n  position: absolute;\n  left: -99999em;\n}\n\n\n.modal {\n  z-index: 1250;\n}\n\n.modal-backdrop {\n  z-index: 1210;\n  // Fix: mobile Safari/Chrome recompute the address-bar-collapsed viewport\n  // height *after* 100vh has already been laid out, so a backdrop sized via\n  // width:100vw/height:100vh (set upstream in psb.scss's vendored Bootstrap\n  // copy) ends up shorter than the real, currently-visible viewport once the\n  // browser chrome collapses during scroll -- revealing the real page behind\n  // the modal along the bottom edge. Anchoring all four sides instead keeps\n  // a `position: fixed` box tracking the live viewport dynamically. The\n  // !important pins this ahead of the upstream 100vw/100vh declarations\n  // regardless of stylesheet load order.\n  top: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  width: auto !important;\n  height: auto !important;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.react-datepicker-wrapper {\n  .form-control {\n    font-size: 0.9rem;\n    font-weight: 100;\n    height: 2.6rem;\n  }\n\n  width: 100%;\n}\n\n.modal-picker {\n  z-index: 999;\n  position: relative;\n}\n\na.fc-col-header-cell-cushion, a.fc-daygrid-day-number {\n  text-decoration: none;\n  color: var(--bs-secondary);\n}\n\na.fc-event {\n  cursor: pointer;\n}\n\n.fc {\n  --fc-button-bg-color: var(--psb-accent);\n  --fc-button-border-color: var(--psb-accent);\n  --fc-button-hover-bg-color: var(--psb-accent);\n  --fc-button-hover-border-color: var(--psb-accent);\n  --fc-button-active-bg-color: var(--psb-accent);\n  --fc-button-active-border-color: var(--psb-accent);\n  --fc-button-text-color: #fff;\n}\n\n.fc .fc-button:active, .fc .fc-button:not(:disabled).fc-button-active {\n  opacity: 0.85;\n}\n\n.bg-invalid-event {\n  cursor: auto;\n  background: #ccc !important;\n}\n\n.modal-card {\n  box-shadow: 0 12px 28px -14px rgba(29,28,42,0.35);\n  border-radius: 14px;\n}\n\n.bg-primary {\n  background: #a1c2e6 !important;\n}\n\n.bg-info {\n  background: #A1C2E6C2 !important;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n@-moz-keyframes spin {\n  from {\n    -moz-transform: rotate(0deg);\n  }\n  to {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spin {\n  animation: spin 1000ms linear infinite;\n}\n\n\n.btn-close {\n  --bs-btn-close-color: #000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.375rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toggle-wrapper {\n  overflow: hidden;\n  transition: height 0.3s ease;\n  position: relative;\n  padding-bottom: 20px;\n}\n\n.toggle-content {\n  transition: opacity 0.2s ease;\n  opacity: 1;\n  padding-right: 60px;\n}\n\n.m-chip {\n  margin-right:0.25rem;\n  margin-bottom:0.25rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.fc-daygrid-event.fc-daygrid-block-event { background-color: transparent !important; border: none !important; }.fc-daygrid-event.fc-daygrid-block-event .fc-event-title { color: #000 !important; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
